import * as PropTypes from 'prop-types';

import { InProgressImportButton } from '../InProgressImportButton';
import { ImportButton } from '../ImportButton';

export const StartImport = ({ importInProgress, beginImport }) => {
    if (importInProgress) {
        return <InProgressImportButton beginImport={beginImport} />;
    }

    return <ImportButton beginImport={beginImport} />;
};

StartImport.propTypes = {
    importInProgress: PropTypes.bool.isRequired,
    beginImport: PropTypes.func.isRequired,
};
